export default __webpack_public_path__ + "static/temple-of-artemis-edd8c981bc29334de7aac848bcbc3f31.jpg";